import {
  AnalyticsProps,
  NESTED_COMPONENT,
  NOT_TRACKED_CONTENT,
} from '../../InternalLibrary/analytics';
import { Link, LinkProps } from 'components/atoms/Link/Link';
import { PropsWithChildren, useCallback } from 'react';
import { useAnalytics } from 'use-analytics';
import Spacer from 'components/atoms/Spacer/Spacer';
import styles from 'components/atoms/Link/Link.module.scss';
import Text from 'components/atoms/Typography/Text';

export interface LinkActorPros extends AnalyticsProps {
  error?: string;
  className?: string;
  linkProps?: Partial<LinkProps>;
  width?: string;
}

export const LinkActor: React.FC<PropsWithChildren<LinkActorPros>> = ({
  error,
  className,
  linkProps = {},
  analytics,
  children,
  width,
}) => {
  const { track } = useAnalytics();

  const onClick = useCallback(
    (e: any) => {
      linkProps?.onClick?.(e);

      if (analytics?.dontTrack) {
        return;
      }

      const content =
        typeof children === 'string' ? children : NESTED_COMPONENT;

      track('click', {
        description: analytics?.description,
        content: analytics?.dontTrackContent
          ? NOT_TRACKED_CONTENT
          : analytics?.contentOverride ?? content,
      });
    },
    [
      linkProps,
      analytics?.dontTrack,
      analytics?.description,
      analytics?.dontTrackContent,
      analytics?.contentOverride,
      children,
      track,
    ],
  );
  // TODO: Style it
  return (
    <div style={{ width }} className={className}>
      <Link {...linkProps} onClick={onClick}>
        {children}
      </Link>
      {error && (
        <Spacer marginVertical="10px">
          <Text
            kind="p"
            level={2}
            className={styles['error-text']}
            dangerouslySetInnerHTML={{
              __html: error,
            }}
          />
        </Spacer>
      )}
    </div>
  );
};
